import React from 'react';
import '../../App.css';
import './ClassProjects.css';

export default function ClassProjects() {
  return (
    <div className='class-project-container'>
      <h1>St. Clair School Projects</h1>

      <div className='class-project-text'>
            <h2>Overview</h2>
            <hr />
            <p>
                These are some projects I completed as part of one of my IT Skills for Proffesionals and includes
                both an elevator pitch to briefly showcase some of my skills,
                as well as a presentation that I did on Machine Learning in Unity. 
            </p>
      </div>

      <div className='class-project-video-section'>
            <h2>Elevator Pitch</h2>
            <video controls className='class-project-video'>
                <source src='videos/elevatorPitch.mp4' type='video/mp4' />
                Your browser does not support the video tag.
            </video>
      </div>

      <div className='class-project-presentation-section'>
        <h2>Presentation</h2>
        <a
          href='presentations/MachineLearning.pdf'
          target='_blank'
          rel='noreferrer'
          className='class-project-link'
        >
          View Presentation PDF
        </a>
      </div>
    </div>
  );
}